// NOTE: loading addons using this file is deprecated!
// please use manager.js and preview.js files instead
require('./manager');
